import { render, staticRenderFns } from "./PreviewText.vue?vue&type=template&id=6ff34ce1"
import script from "./PreviewText.vue?vue&type=script&lang=js"
export * from "./PreviewText.vue?vue&type=script&lang=js"
import style0 from "./PreviewText.vue?vue&type=style&index=0&id=6ff34ce1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports